import React, { useEffect, useState } from 'react'
import { useStateContext } from '@xkit-yx/im-kit-ui'
import general, { redux } from '../../general'

export default function IMUnreadNum(props) {

  const { store, nim } = useStateContext()
  const [allUnread, setAllUnread] = useState(0)
  const [tidUnread, setTidUnread] = useState(0)

  const accumulatedUnread = () => {
    let unread = 0
    const key = `chat-mute-list-${localStorage.getItem('yx_account')}`
    if (!localStorage.getItem(key)) {
      store.sessionStore.sessions.forEach((session, key) => {
        unread += session.unread
        if (session.id.split('-')[1] == props.tid) {
          setTidUnread(session.unread)
        }
      })
      setAllUnread(unread)
      return
    }
    const sessionStr = localStorage.getItem(key)
    const muteSession = JSON.parse(sessionStr)
    store.sessionStore.sessions.forEach((session, key) => {
      if (!muteSession.includes(session.id.split('-')[1])) {
        unread += session.unread
        if (session.id.split('-')[1] == props.tid) {
          setTidUnread(session.unread)
        }
      }
    })
    
    setAllUnread(unread)
  }

  useEffect(() => {
    setTimeout(() => {
      accumulatedUnread()
    }, 1000);
  }, [])

  useEffect(() => {

    nim.on('msg', () => {
      accumulatedUnread()
    })

    redux.subscribe(() => {
      let clearChatUnRead = redux.getState().clearChatUnRead;
      if (clearChatUnRead) {
        setAllUnread(0)
      }
    })

    redux.subscribe(() => {
      let updateChatUnread = redux.getState().updateChatUnread;
      if (updateChatUnread) {
        accumulatedUnread()
      }
    })

  }, [])

  return (
    <div>
      {props.tid && <div>{tidUnread > 99 ? '99+' : (tidUnread > 0 ? tidUnread : '')}</div>}
      {!props.tid && <div>{allUnread > 99 ? '99+' : (allUnread > 0 ? allUnread : '')}</div>}
    </div>
  )
}
